import { ensureDefined } from '@avantia/client-and-server-utilities';
import { destructureControlId, HpAddressItemResponse, HpAddressSelectActionProps } from '@avantia/questionset-model';
import { registerConfigurationAction } from '../config/registerClientConfig';
import { applyChanges } from '../reducers/reducerLibrary';
import {
  HpAddressItemFailedPayload,
  HpAddressItemPayload,
  HpCreateActionPromisesProps,
  HpDependentActionFunction,
  HpDispatchFunction
} from '../types';
import { fetchResolver } from './fetchResolver';
import { promiseVoidToFalse } from './promiseVoidToFalse';

let websiteEndpoint: string;
registerConfigurationAction((config) => {
  ({ websiteEndpoint } = config);
});

export function getAddressItemAction({
  question,
  payload,
  dependentAction
}: HpCreateActionPromisesProps): HpDependentActionFunction<HpAddressItemPayload> {
  const { value: addressId } = ensureDefined(payload, 'payload');
  const props = ensureDefined(dependentAction, 'dependentAction').props as HpAddressSelectActionProps;
  const { lookupResultsId, searchFields, errorLoadingAddressMessage } = ensureDefined(props, 'props');
  const questionId = question.questionId;
  const { groupNumber } = destructureControlId(questionId, { requirePrefix: false });
  const addressFailedPayload: HpAddressItemFailedPayload = {
    lookupResultsId,
    errorLoadingAddressMessage:
      errorLoadingAddressMessage ||
      "Sorry, we're having problems loading the address you selected. Please try again, or enter your address manually.",
    groupNumber
  };
  return (dispatch: HpDispatchFunction<HpAddressItemPayload>): Promise<boolean> => {
    return promiseVoidToFalse(
      fetchResolver<never, HpAddressItemPayload>({
        options: {
          url: `${websiteEndpoint}/api/address-lookup/id/${encodeURIComponent(String(addressId))}`,
          method: 'GET',
          description: `Get address ID (${addressId})`
        },
        loadingPageType: 'overlay',
        showErrorPage: false,
        dispatch,
        successAction: (serverPayload) => {
          const itemPayload = serverPayload as HpAddressItemResponse;
          const { success } = itemPayload;
          if (success === true) {
            const part: Partial<HpAddressItemPayload> = { questionId, lookupResultsId, searchFields, groupNumber };
            const payload = applyChanges(part as HpAddressItemPayload, itemPayload);
            dispatch({
              type: 'ADDRESS_ITEM_RETRIEVED',
              payload
            });
          } else {
            // If we want to go to the error page, dispatch FETCH_ERROR_OCCURRED action instead.
            dispatch({
              type: 'ADDRESS_ITEM_FAILED',
              payload: addressFailedPayload as any
            });
          }
        },
        failedAction: () => {
          dispatch({
            type: 'ADDRESS_ITEM_FAILED',
            payload: addressFailedPayload as any
          });
        }
      })
    );
  };
}
